import React, { Component } from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import { translationHook } from "../../../translationHook";
import { Form } from "react-final-form";
import { TextField, Switches, Select } from "mui-rff";
import apiConfig from "../../../../apis/apiConfig";
import { validateDonationBandData } from "../../../../apis/charity/donationBands/validateDonationBandData";
import { ButtonPrimary } from "../../../UI/Buttons";
import { setLoading, triggerNotification, triggerDialogForm } from "../../../../actions";

class BandForm extends Component {
    constructor(props) {
		super(props);
		this.state = {
			showForm: false,
            donationsTypesList: []
		};
	}

    getDonationsTypes = async () => {
		let donationsTypesArr = [];
        const at = this.props.currentUser.Data.access_token,
        url = "/API/CHARITY/LOOKUPS/Donations_Types/DDL_Donations_Types"
		const response = await apiConfig.post(url, {}, {
            headers: {
                Authorization: `Bearer ${at}`,
            },
        });

		if (response.data.Status) {
            console.log(response.data.Data)
			response.data.Data.map((item) => {
				let label =
					this.props.i18n.language === "ar"
						? item.Donation_Type_Name_AR
						: item.Donation_Type_Name_ER;

                donationsTypesArr.push({ value: item.Donation_Type_Id, label });
			});

			this.setState({ donationsTypesList: donationsTypesArr });
		}
	};

    handleSubmit = async (values, form) => {
		const at = this.props.currentUser.Data.access_token,
			url = this.props.editMood
				? "/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Update_Donation_Band"
				: "/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Add_Donation_Band";
		let body = {
			...values,
			Active_Status_Id: values.Active_Status_Id ? 1 : 0,
		};

		if (this.props.editMood) {
			body = { Donation_Band_Id: this.props.donationBandId, ...body };
		}

		this.props.setLoading(true, "dark");

		const response = await apiConfig
			.post(url, body, {
				headers: {
					Authorization: `Bearer ${at}`,
				},
			})
			.catch((error) => {
				return error.response;
			});

		if (response.data.Status) {
			form.restart();
		}

		if (this.props.editMood) {
			this.props.triggerDialogForm(false);
		}

		this.props.triggerNotification(true, response.data);

		this.props.setLoading(false);

		if (this.props.submitCB) {
			this.props.submitCB();
		}
	};

    componentDidMount() {
        this.getDonationsTypes();
    };

    render() {
        let { initValues } = this.props;

        const validate = async (values) => {
            const errors = {};
            const at = this.props.currentUser.Data.access_token;

            await validateDonationBandData(at, values).then((res) => {
                if (res?.Data?.Validation_Results_List?.length) {
                    res?.Data?.Validation_Results_List.forEach((f) => {
                        if (!f.Result) {
                            errors[f.Input_Name] =
                                this.props.i18n.language === "ar"
                                    ? f.Error_AR
                                    : f.Error_EN;
                        }
                    });
                }
            });

            return errors;
        };

        return (
            <>
                {!this.props.editMood && !this.props.viewMood && (
                    <div className="d-flex justify-content-between align-items-center pb-5">
                        <h3>{this.props.t("donationBandsList")}</h3>
                        <ButtonPrimary
                            variant={
                                !this.state.showForm ? "contained" : "outlined"
                            }
                            onClick={() =>
                                this.setState({
                                    showForm: !this.state.showForm,
                                })
                            }
                        >
                            {!this.state.showForm && this.props.t("addDonationBand")}
                            {this.state.showForm && this.props.t("cancel")}
                        </ButtonPrimary>
                    </div>
                )} 

                
                <Form
                    validateOnBlur={true}
                    subscription={{ submitting: true }}
                    onSubmit={this.handleSubmit}
                    initialValues={
                        initValues
                            ? initValues
                            : {
                                    Active_Status_Id: 1,
                                    Donation_Band_Name_AR: "",
                                    Donation_Band_Name_EN: "",
                                    Donation_Type_Id: "",
                                    Start_Balance_Value: "",
                                    Administration_Fees_Ratio: "",
                                }
                    }
                    validate={validate}
                    render={({ handleSubmit, form, submitting }) => (
                        <form
							className={`row pt-5 px-3 ${
								!this.state.showForm &&
								!this.props.editMood &&
								!this.props.viewMood
									? "d-none"
									: ""
							}`}
							onSubmit={handleSubmit}
							noValidate
						>
                            <Col xs={12} md={6}>
                                <TextField
                                    disabled
                                    label={this.props.t("idNo")}
                                    className={`read-only mb-2`}
                                    name="Donation_Band_Id"
                                    autoComplete="off"
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <Select
                                    disabled={this.props.viewMood}
                                    label={this.props.t("donationType")}
                                    className={`${this.props.viewMood ? "read-only" : ""}`}
                                    required={true}
                                    name="Donation_Type_Id"
                                    data={this.state.donationsTypesList}
                                    showError={() => {
                                        let fieldStatus =
                                            form.getFieldState(
                                                "donationTypeID"
                                            );

                                        if (fieldStatus) {
                                            return (
                                                fieldStatus.submitFailed &&
                                                fieldStatus.invalid
                                            );
                                        }
                                    }}
                                ></Select>
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("nameAr")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    required={true}
                                    name="Donation_Band_Name_AR"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("nameEn")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    required={true}
                                    name="Donation_Band_Name_EN"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("startBalance")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    name="Start_Balance_Value"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("administrationFeesRatio")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    name="Administration_Fees_Ratio"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col
                                xs={12}
                                md={2}
                                className={`${
                                    this.props.viewMood ? "read-only" : ""
                                }`}
                            >
                                <Switches
                                    disabled={this.props.viewMood}
                                    color="primary"
                                    name="Active_Status_Id"
                                    data={{
                                        label: `${this.props.t(
                                            "serviceStatus"
                                        )}`,
                                        defaultValue: `${this.props.t(
                                            "serviceStatus"
                                        )}`,
                                    }}
                                />
                            </Col>

                            <Col
                                className="my-4 justify-content-start d-flex"
                                xs={12}
                            >
                                {!this.props.viewMood && (
                                    <ButtonPrimary
                                        color="primary"
                                        variant="contained"
                                        disabled={
                                            submitting || this.props.viewMood
                                        }
                                        type="submit"
                                    >
                                        {this.props.t("save")}
                                    </ButtonPrimary>
                                )}
                            </Col>
                        </form>
                    )}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return { currentUser: state.currentUser };
};

export default connect(mapStateToProps, {
    triggerNotification,
    setLoading,
    triggerDialogForm,
})(translationHook(BandForm));